import api from "./api";

export async function getCars(params) {
  const res = await api.get("/admin/cars", { params });
  return res.data.data; 
}

export async function getCar(id) {
    const res = await api.get(`/admin/cars/${id}`);
    return res.data.data;
}

export async function approveCar(id) {
    const res = await api.post(`/admin/cars/${id}/approve`);
    return res.data.data;
}

export async function disapproveCar(id) {
    const res = await api.post(`/admin/cars/${id}/disapprove`);
    return res.data.data;
}

export async function deleteCar(id) {
    const res = await api.delete(`/admin/cars/${id}`);
    return res.data.data;
}


// export const getCars = (params) => api.get("/admin/cars", { params }).then(res => res.data);
// export const approveCar = (id) => api.post(`/admin/cars/${id}/approve`);
// export const disapproveCar = (id) => api.post(`/admin/cars/${id}/disapprove`);
// export const deleteCar = (id) => api.delete(`/admin/cars/${id}`);